// extracted by mini-css-extract-plugin
export default {"tabList":"ProjectsTabs_tabList__bYmVg react-tabs__tab-list"};